import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["enabled"];
import { DomainProductTypeEnum, RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { findDomainInQuery, parseDomain, withTopRecommendations } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { getSharedQueryClient } from '@wix/premium-fed-sdk/@apis-infra-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useInfiniteQuery } from 'react-query';
const DEFAULT_LIMIT = 10;
export const getSuggestionsQueryKey = _ref => {
  let query = _ref.query,
    tlds = _ref.tlds,
    limit = _ref.limit,
    uniqueSldsOnly = _ref.uniqueSldsOnly,
    productType = _ref.productType;
  return ['suggestDomains', query, tlds, ...(limit ? [limit] : []), ...(uniqueSldsOnly ? [uniqueSldsOnly] : []), ...(productType ? [productType] : [])];
};
const toRecommendation = _ref2 => {
  let domain = _ref2.domain,
    premium = _ref2.premium,
    label = _ref2.label;
  const _parseDomain = parseDomain(domain),
    asciiDomain = _parseDomain.asciiDomain,
    formattedInput = _parseDomain.formattedInput;
  return {
    id: asciiDomain,
    domain: formattedInput,
    premium: premium ?? false,
    label
  };
};
const fetchExactMatch = async (_ref3, query) => {
  let checkDomainAvailability = _ref3.checkDomainAvailability;
  const parsedQuery = findDomainInQuery(query);
  if (!parsedQuery) {
    return undefined;
  }
  try {
    const _await$checkDomainAva = await checkDomainAvailability({
        domain: parsedQuery.asciiDomain
      }, {
        useErrorBoundary: false
      }),
      availability = _await$checkDomainAva.availability;
    return availability != null && availability.available && availability.domain ? {
      domain: availability.domain,
      premium: availability.premium,
      label: RecommendationLabel.EXACT_MATCH
    } : undefined;
  } catch {
    return undefined;
  }
};
const fetchSuggestionsPage = async (queries, _ref4) => {
  var _pagingMetadata$curso;
  let query = _ref4.query,
    tlds = _ref4.tlds,
    _ref4$limit = _ref4.limit,
    limit = _ref4$limit === void 0 ? DEFAULT_LIMIT : _ref4$limit,
    cursor = _ref4.cursor,
    uniqueSldsOnly = _ref4.uniqueSldsOnly,
    productType = _ref4.productType;
  const exactMatchPromise = cursor ? undefined : fetchExactMatch(queries, query);
  const _await$queries$sugges = await queries.suggestDomains({
      query,
      tlds,
      paging: {
        limit,
        cursor
      },
      ...(uniqueSldsOnly ? {
        uniqueSldsOnly
      } : {}),
      ...(productType === DomainProductTypeEnum.BASE44 ? {
        excludePremiumDomains: true
      } : {})
    }),
    _await$queries$sugges2 = _await$queries$sugges.suggestions,
    suggestions = _await$queries$sugges2 === void 0 ? [] : _await$queries$sugges2,
    pagingMetadata = _await$queries$sugges.pagingMetadata;
  const named = suggestions.filter(suggestion => !!suggestion.domain);
  const exactMatch = await exactMatchPromise;
  const rows = withTopRecommendations(query, named).filter(suggestion => suggestion.domain !== (exactMatch == null ? void 0 : exactMatch.domain));
  if (exactMatch) {
    rows.unshift(exactMatch);
  }
  return {
    recommendations: rows.map(toRecommendation),
    nextCursor: pagingMetadata != null && pagingMetadata.hasNext && pagingMetadata.count === limit ? ((_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next) ?? undefined : undefined
  };
};
export const useSuggestions = _ref5 => {
  let enabled = _ref5.enabled,
    request = _objectWithoutPropertiesLoose(_ref5, _excluded);
  const queries = DomainsApiClient.useQueries();
  return useInfiniteQuery({
    queryKey: getSuggestionsQueryKey(request),
    enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
    queryFn: _ref6 => {
      let pageParam = _ref6.pageParam;
      return fetchSuggestionsPage(queries, {
        ...request,
        cursor: pageParam
      });
    },
    getNextPageParam: lastPage => lastPage == null ? void 0 : lastPage.nextCursor
  });
};
export const prefetchSuggestions = request => {
  const _ref7 = getPremiumEssentialsSafe() ?? {},
    httpClient = _ref7.httpClient;
  if (!httpClient) {
    return;
  }
  const queries = DomainsApiClient.queries({
    httpClient
  });
  getSharedQueryClient().prefetchInfiniteQuery({
    queryKey: getSuggestionsQueryKey(request),
    queryFn: () => fetchSuggestionsPage(queries, request)
  });
};
//# sourceMappingURL=useSuggestions.js.map